import { SupabaseEventRecord } from '@interfaces';

export function getEventImageSrcSet(
	imageUrls: SupabaseEventRecord['image_urls'],
) {
	if (!imageUrls.length) return;

	const srcSet = imageUrls.reduce((accumulator: string[], imageUrl) => {
		const url = new URL(imageUrl);
		const width = url.searchParams.get('w');

		if (width) {
			accumulator.push(`${imageUrl} ${width}w`);
		}

		return accumulator;
	}, []);

	return srcSet.join(', ');
}
